import React from 'react';
import './style.scss';

const Footer: React.FC = () => {
	return (
		<footer className="footer">
			<section className="footer__inner">
				<p>Copyright 2025 &copy; PT. Ketaren Jaya Transport</p>
			</section>
		</footer>
	);
};

export default Footer;
